import React from 'react';
import { BUTTON_STYLES } from 'constants/styles';
import { ValidationWarning } from 'components/mealplan/StatusMessages';
import SubstitutionBadge from './SubstitutionBadge';

const StarchSubstitutionSection = ({ order, orderIndex, onStarchSubstitution, isLocked, saving, autoSubstitution }) => {
    if (!order.starchOptions || order.starchOptions.length === 0) {
        return null;
    }

    const showAutoSubBadge = autoSubstitution?.addedId &&
        order.starchOptions.some(opt => opt.id === autoSubstitution.addedId && opt.isActive);

    const getActiveStarchCount = () => {
        if (!order.starchOptions) return null
        return order.starchOptions.filter(option => option.isActive).length;
    };

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Starch:
                {showAutoSubBadge && (
                    <SubstitutionBadge
                        removedName={autoSubstitution.removedName}
                        addedName={autoSubstitution.addedName}
                    />
                )}
            </label>
            {getActiveStarchCount() !== null && getActiveStarchCount() !== undefined && getActiveStarchCount() < 1 && (
                <ValidationWarning message="No Starch Selected" />
            )}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {order.starchOptions.map((starchOption, index) => {
                    const isActive = starchOption.isActive;
                    // Selected option stays clickable so it can be removed — clicking
                    // it deselects (starch is optional). Previously the active button
                    // was disabled, so a dish's only starch could never be removed.
                    const isDisabled = isLocked || saving;
                    const subs = (starchOption.subIngredientNames || []).map(s => (s || '').replace(/^SF /, ''));
                    const title = subs.length > 0
                        ? `${starchOption.name}: ${subs.join(', ')}`
                        : (isActive ? `Remove ${starchOption.name}` : `Choose ${starchOption.name}`);

                    return (
                        // Tooltip lives on this wrapper, not the button — Chromium
                        // won't show a title tooltip on a disabled button.
                        <span key={index} title={title}>
                            <button
                                onClick={() => {
                                    if (!onStarchSubstitution) return;
                                    if (isActive) {
                                        onStarchSubstitution(orderIndex, null, starchOption.id);
                                        return;
                                    }
                                    const currentActiveStarch = order.starchOptions.find(opt => opt.isActive);
                                    const oldStarchId = currentActiveStarch ? currentActiveStarch.id : null;
                                    onStarchSubstitution(orderIndex, starchOption.id, oldStarchId);
                                }}
                                disabled={isDisabled}
                                style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                                data-testid={`starch-option-${starchOption.id}`}
                            >
                                <span style={{
                                    marginRight: '4px',
                                    fontSize: '12px'
                                }}>
                                    {isActive ? '✓' : '+'}
                                </span>
                                {starchOption.name}
                            </button>
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default StarchSubstitutionSection;